/* 热点内容 */
import React, { useEffect, useState, SyntheticEvent } from 'react'
import { useInView } from 'react-intersection-observer'
import useVisible from 'Components/hooks/use-visible'
import get from 'lodash/get'
import getUrl from 'lib/url'

import ArticleLink from 'Components/links/article-link'
import { IFeedData } from 'lib/fetch-feed'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import fetch from 'lib/decorated-fetch'
import HotNewsRightAD from './ad/hot-news-right'
import applyHttpsImage from 'lib/apply-https-img'
import ToggleImgGroup, { LiveData } from 'Components/toggle-image-group'
import Link from 'next/link'
import formatNumber from '@arsenal/arsenal/modules/formatNumber'
import formatTime from 'lib/format-time'
import { renderTitle } from 'Pages/live/home'

const live_black_gif = require('static/live-black.gif')
const default_svg = require('static/default.png')
interface IProps {
  hotSpot: IFeedData[]
}

export default function HotNews({ hotSpot }: IProps) {
  const [ref, inView] = useInView({
    threshold: 0,
  })
  const isVisible = useVisible()
  const [hasShow, setHasShow] = useState(false)
  const [slideIndex, setSlideIndex] = useState(0)
  const [liveDatas, setLiveDatas] = useState<LiveData[]>([])
  const [loaded, setLoaded] = useState<0 | 1 | 2>(0) // 0未加载 1已加载 2加载失败

  useEffect(() => {
    if (liveDatas.length === 0) {
      fetch(getUrl('/motor/m_api/pc_live_rooms'))
        .then(json => {
          setLoaded(1)
          setLiveDatas(
            json.data?.filter((e: LiveData) => {
              return e?.type !== 0 || false
            })
          )
        })
        .catch(error => {
          setLoaded(2)
          console.error(error)
        })
    }
  }, [])
  const {
    room_id = '',
    preview_id = '',
    type = 0,
    title = '',
    create_time = NaN,
    popularity = 0,
    user_info = {
      user_name: '',
      avatar: '',
      user_id_str: '',
    },
  } = liveDatas.length > 0 ? liveDatas[slideIndex] : {}
  const author_profile_url = `/user/ugc_profile/${user_info.user_id_str}`
  let date
  if (!Number.isNaN(create_time)) {
    date = new Date(create_time * 1000)
  }
  const live_card_img_group = liveDatas.map(e => e.cover_url)
  const room_ids = liveDatas.map(e => e.room_id)
  useEffect(() => {
    if (!hasShow && inView && isVisible && hotSpot.length) {
      sendTeaCommEvent('show_hot_news_potrait', {
        group_id: get(hotSpot, `[0].unique_id_str`, ''),
        content_type: get(hotSpot, `[0].type`, ''),
      })
      sendTeaCommEvent('show_hot_news_potrait', {
        group_id: get(hotSpot, `[${hotSpot.length - 1}].unique_id_str`, ''),
        content_type: get(hotSpot, `[${hotSpot.length - 1}].type`, ''),
      })
      sendTeaCommEvent('show_hot_news_list')
      setHasShow(true)
    }
  }, [hasShow, hotSpot, inView, isVisible])
  return (
    <section ref={ref}>
      <div className="news-wrapper" id="hot_news">
        <div className="live-card">
          <div className="live-card-top">
            {live_card_img_group.length > 0 && (
              <Link href={author_profile_url}>
                <a target="_blank" className="author-wrapper">
                  <img
                    className="author-logo"
                    src={user_info.avatar}
                    alt="作者头像"
                  />
                  <span className="author-name">{user_info.user_name}</span>
                </a>
              </Link>
            )}
          </div>
          <div
            className="live-card-main"
            onClick={(e: SyntheticEvent) => {
              const target = e.target as HTMLElement
              const prevPressed = target.classList.contains(
                'swiper-button-prev'
              )
              const nextPressed = target.classList.contains(
                'swiper-button-next'
              )
              if (prevPressed || nextPressed) {
                sendTeaCommEvent('click_home_live_banner_switch', {
                  switch_direction: nextPressed ? 'right' : 'left',
                })
                return
              }
              sendTeaCommEvent('click_home_live_banner', {
                rank: slideIndex,
                anchor_id: user_info.user_id_str,
                room_id,
                is_live_preview: type === 2 ? 1 : 0,
              })
            }}
          >
            <div className="img-wrapper">
              {live_card_img_group.length > 1 && (
                <ToggleImgGroup
                  imgArray={live_card_img_group}
                  room_ids={room_ids}
                  setSlideIndex={a => {
                    setSlideIndex(a)
                  }}
                  show_home_live_banner_tea={index => {
                    sendTeaCommEvent('show_home_live_banner', {
                      rank: index,
                      room_id,
                      anchor_id: user_info.user_id_str,
                      is_live_preview: type === 2 ? 1 : 0,
                    })
                  }}
                >
                  {
                    <div className="live-box">
                      <span className="live-box-left">
                        {type === 1 && (
                          <img src={live_black_gif} className="living-gif" />
                        )}
                        {type === 1 ? '直播中' : '直播预告'}
                      </span>
                      <span className="live-box-right">
                        <span>
                          {type === 1
                            ? `${formatNumber(popularity)}人在观看`
                            : date && formatTime(date.getTime())}
                        </span>
                      </span>
                    </div>
                  }
                </ToggleImgGroup>
              )}
              {live_card_img_group.length === 1 && (
                <img
                  className="alternative-image"
                  src={live_card_img_group[0]}
                />
              )}
              {live_card_img_group.length === 0 && (
                <img className="alternative-image" src={default_svg} />
              )}
            </div>
          </div>
          <div className="live-card-bot">
            <a
              // eslint-disable-next-line react/jsx-no-target-blank
              target="_blank"
              rel="unsafe-url"
              href={`https://live.ixigua.com/room/${room_ids[slideIndex]}/`}
            >
              {renderTitle(
                live_card_img_group.length === 0,
                title,
                loaded,
                {
                  margin: '14px 0 0 12px',
                  height: '22px',
                  fontSize: '16px',
                  color: '#1f2129',
                  fontWeight: 500,
                },
                {
                  textAlign: 'center',
                  fontSize: '16px',
                  fontWeight: 500,
                  color: '#606370',
                }
              )}
            </a>
          </div>
        </div>
        <ul>
          {hotSpot
            .slice(1, hotSpot.length - 1)
            .slice(0, 8)
            .map((item: IFeedData, index) => (
              <li className="line-1" key={item.unique_id_str}>
                <ArticleLink
                  className="article-link"
                  gid={item.unique_id_str}
                  onClick={(gid: string) => {
                    sendTeaCommEvent('click_hot_news_cell', {
                      group_id: gid,
                      content_type: `${item.type}`,
                      rank: index,
                    })
                  }}
                >
                  {item.info.title}
                </ArticleLink>
              </li>
            ))}
        </ul>
        <HotNewsRightAD>
          <ArticleLink
            gid={get(hotSpot, `[${hotSpot.length - 1}].unique_id_str`, '')}
            onClick={(gid: string) => {
              sendTeaCommEvent('click_hot_news_potrait', {
                group_id: gid,
                content_type: get(hotSpot, `[${hotSpot.length - 1}].type`, ''),
              })
            }}
          >
            <div className="ad-pic fr">
              <img
                src={`${applyHttpsImage(
                  get(
                    hotSpot,
                    `[${hotSpot.length - 1}].info.image_list[0].url`,
                    ''
                  )
                )}`}
                className="ad-pic-bg"
              />
              <div className="pic-mask">
                <span className="pic-title">
                  {get(hotSpot, `[${hotSpot.length - 1}].info.title`, '')}
                </span>
              </div>
            </div>
          </ArticleLink>
        </HotNewsRightAD>
      </div>
      <style jsx>
        {`
          .img-wrapper {
            vertical-align: top;
            display: inline-block;
            width: 380px;
            height: 214px;
          }
          .alternative-image {
            display: inline-block;
            max-width: 100%;
            width: 100%;
            height: 100%;
            object-fit: cover;
            object-position: center;
          }

          .live-card-top {
            height: 40px;
            padding: 11px 12px;
          }
          .live-show-img {
            margin-left: 16px;
            display: inline-block;
            width: 24px;
            height: 24px;
            object-fit: cover;
            object-position: center;
          }
          .live-card-type {
            margin-left: 8px;
            font-size: 24px;
            font-weight: 500;
            line-height: 1.5;
          }
          .author-wrapper {
            display: inline-flex;
            align-items: center;
          }
          .author-logo {
            flex: 0 0 auto;
            border-radius: 50%;
            width: 16px;
            height: 16px;
            background-color: rgba(255, 255, 255, 0.08);
            cursor: pointer;
            object-fit: cover;
            object-position: center;
            min-width: 0;
          }
          .author-name {
            margin-left: 4px;
            overflow: hidden;
            text-overflow: ellipsis;
            color: #1f2129;
            cursor: pointer;
            white-space: nowrap;
            min-width: 0;
          }
          .live-card {
            vertical-align: top;
            display: inline-block;
            width: 380px;
            border-radius: 2px;
            background-color: #f2f4fa;
          }
          .live-card-main {
            cursor: pointer;
          }
          .live-card-bot {
            height: 52px;
            overflow: hidden;
            cursor: pointer;
          }
          .live-box {
            position: absolute;
            display: flex;
            align-items: center;
            height: 24px;
            z-index: 1;
            bottom: 8px;
            left: 12px;
          }

          .live-box-left {
            display: inline-flex;
            align-item: center;
            padding: 4px;
            height: 24px;
            border-radius: 2px 0 0 2px;
            background-color: #ffcc32;
            font-size: 12px;
            font-weight: 500;
            line-height: 1.33;
          }
          .living-gif {
            width: 16px;
            height: 16px;
            object-fit: cover;
            object-position: center;
          }

          .live-box-right {
            position: relative;
            padding: 6px 8px;
            height: 24px;
            border-radius: 0 2px 2px 0;

            font-size: 12px;
            font-weight: 500;
            line-height: 1;
            color: white;
          }
          .live-box-right > span {
            position: relative;
          }
          .live-box-right::before {
            left: 0;
            top: 0;
            position: absolute;
            content: '';
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.8);
          }

          .news-wrapper {
            padding-top: 40px;
          }
          ul {
            display: inline-block;
            margin: 4px 16px;
            height: 297px;
            overflow: hidden;
          }
          li {
            position: relative;
            width: 396px;
            height: 24px;
            margin-bottom: 15px;
            padding-left: 8px;
            font-size: 16px;
            box-sizing: content-box;
            color: #1a1a1a;
            cursor: pointer;
          }
          li::before {
            content: '';
            display: inline-block;
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background-color: #d8d8d8;
            position: relative;
            right: 8px;
            top: -2px;
          }
          .news-pic {
            position: relative;
            width: 380px;
            height: 250px;
            background-image: url(${applyHttpsImage(
      get(hotSpot, `[0].info.image_list[0].url`, '')
    )});
            background-size: cover;
          }
          .ad-pic {
            position: relative;
            width: 380px;
            height: 305px;
            border-radius: 2px 2px 0 0;
            overflow: hidden;
          }
          .ad-pic-bg:hover {
            transform: scale(1.1);
          }
          .ad-pic-bg {
            position: absolute;
            width: 100%;
            height: 253px;
            object-fit: cover;
            object-position: 0 0;
            transition: transform 0.3s ease-in-out;
          }
          .pic-mask {
            position: absolute;
            width: 100%;
            padding: 15px 16px;
            bottom: 0;
            height: 52px;
            font-size: 16px;
            font-weight: 500;
            border-radius: 0 0 2px 2px;
            color: #1f2129;
            background-color: #f2f4fa;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .fr {
            float: right;
          }
        `}
      </style>
    </section>
  )
}
